import { useLocale } from "@acto/web-common/locales";
import {
  formatDayShortMonthYear,
  formatMonth,
  formatRelativeDays,
  formatWeekdayShortDayMonth,
} from "@acto/taskpane/field-sales-2/utils/format";

export const useDateFormatter = () => {
  const { locale } = useLocale();

  return {
    formatMonth: (value: string | Date): string => formatMonth(value, locale),
    formatDayShortMonthYear: (value: string | Date): string => formatDayShortMonthYear(value, locale),
    formatRelativeDays: (value: string | Date): string => formatRelativeDays(value, locale),
    formatWeekdayShortDayMonth: (value: string | Date): string => formatWeekdayShortDayMonth(value, locale),
  };
};
